var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "new-email-modal-form" },
    [
      _c(
        "h3",
        [
          _vm._v("MASSENEMAILS AN LEISTUNGSTRÄGER"),
          _vm.bulkGroups.length > 0
            ? [_vm._v(" — " + _vm._s(_vm.bulkGroups.length) + " EMAILS")]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("bulk-provider-select", { attrs: { options: _vm.requestOptions } }),
      _vm._v(" "),
      _c("div", { staticClass: "bulk-separator" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-wrapper" },
        [
          _c("label", [_vm._v("Von:")]),
          _vm._v(" "),
          _vm.isListMode
            ? _c("multiselect", {
                attrs: {
                  options: _vm.senderOptions,
                  label: "label",
                  "track-by": "key",
                  "allow-empty": false,
                },
                model: {
                  value: _vm.senderOption,
                  callback: function ($$v) {
                    _vm.senderOption = $$v
                  },
                  expression: "senderOption",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isListMode || _vm.sender === "me"
            ? _c("email-select", {
                model: {
                  value: _vm.newEmail.fromEmail,
                  callback: function ($$v) {
                    _vm.$set(_vm.newEmail, "fromEmail", $$v)
                  },
                  expression: "newEmail.fromEmail",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-wrapper" },
        [
          _c("label", [_vm._v("Vorlage:")]),
          _vm._v(" "),
          _c("template-selection"),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-wrapper" }, [
        _c("label", [_vm._v("Betreff:")]),
        _vm._v(" "),
        _c("div", {
          ref: "subjectEditor",
          staticClass: "input bulk-subject-input",
          attrs: {
            contenteditable: "true",
            spellcheck: "false",
            title:
              "Änderungen gelten für alle Emails — graue Bausteine werden pro Empfänger automatisch befüllt (Doppelklick wandelt sie in normalen Text um)",
          },
          on: {
            input: _vm.onSubjectInput,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
            },
            dblclick: _vm.onSubjectDblclick,
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-wrapper" },
        [
          _c("label", [_vm._v("Beschreibung:")]),
          _vm._v(" "),
          _c("tag-select", {
            attrs: { "option-tags": _vm.optionTags, "my-class": "is-medium" },
            model: {
              value: _vm.tags,
              callback: function ($$v) {
                _vm.tags = $$v
              },
              expression: "tags",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.requestOptions && _vm.requestOptions.statuses
        ? _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("Status ändern:")]),
              _vm._v(" "),
              _c("multiselect", {
                attrs: {
                  placeholder: "nicht ändern",
                  options: _vm.requestOptions.statuses,
                  label: "value",
                  "track-by": "key",
                },
                model: {
                  value: _vm.status,
                  callback: function ($$v) {
                    _vm.status = $$v
                  },
                  expression: "status",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-wrapper" },
        [
          _c("label", [_vm._v("Neue Aufgabe:")]),
          _vm._v(" "),
          _c("input-date", {
            model: {
              value: _vm.newEmail.todoDate,
              callback: function ($$v) {
                _vm.$set(_vm.newEmail, "todoDate", $$v)
              },
              expression: "newEmail.todoDate",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "attachments" },
        [
          _c("label", [_vm._v("Anhänge:")]),
          _vm._v(" "),
          _c("attachments", {
            attrs: { ordersSelected: _vm.ordersSelected },
            model: {
              value: _vm.newEmail._files,
              callback: function ($$v) {
                _vm.$set(_vm.newEmail, "_files", $$v)
              },
              expression: "newEmail._files",
            },
          }),
          _vm._v(" "),
          _c("br"),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pell-wrapper" }, [
        _c("label", [_vm._v("Email:")]),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "z-index": "0" } },
          [
            _c("div", { staticClass: "bulk-editor-nav" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  attrs: {
                    disabled: _vm.previewIndex <= 0 || _vm.isRendering,
                    title: "Vorherige Email (Pfeil links)",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.previewIndex--
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("chevron_left"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button",
                  attrs: {
                    disabled:
                      _vm.previewIndex >= _vm.bulkGroups.length - 1 ||
                      _vm.isRendering,
                    title: "Nächste Email (Pfeil rechts)",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.previewIndex++
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("chevron_right"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.currentGroup
                ? _c(
                    "div",
                    [
                      _c("b", [
                        _vm._v(
                          "Email " +
                            _vm._s(_vm.previewIndex + 1) +
                            " / " +
                            _vm._s(_vm.bulkGroups.length) +
                            " — " +
                            _vm._s(_vm.currentGroup.provider.name)
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.currentContact
                        ? [_vm._v(" an " + _vm._s(_vm.currentContact.email))]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isListMode && _vm.currentSender.fromEmail
                        ? [
                            _vm._v(
                              " – von " +
                                _vm._s(_vm.currentSender.fromEmail.email)
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                : _c("div", [_c("b", [_vm._v("Keine Leistungen ausgewählt")])]),
              _vm._v(" "),
              _c(
                "i",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value:
                        "Änderungen gelten für alle Emails. Die grau hinterlegten Bausteine werden pro Empfänger automatisch befüllt — sie können gelöscht oder per Doppelklick in normalen (für alle gleichen) Text umgewandelt, aber nicht direkt bearbeitet werden. Mit ←/→ durch die Emails blättern.",
                      expression:
                        "'Änderungen gelten für alle Emails. Die grau hinterlegten Bausteine werden pro Empfänger automatisch befüllt — sie können gelöscht oder per Doppelklick in normalen (für alle gleichen) Text umgewandelt, aber nicht direkt bearbeitet werden. Mit ←/→ durch die Emails blättern.'",
                    },
                  ],
                  staticClass: "material-icons bulk-editor-info",
                },
                [_vm._v("info_outline")]
              ),
            ]),
            _vm._v(" "),
            _vm.isRendering ? _c("loading") : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                [
                  _c("email-editor", {
                    on: {
                      keyup: _vm.registerKeyUp,
                      dblclick: _vm.onEditorDblclick,
                    },
                    model: {
                      value: _vm.editorHtml,
                      callback: function ($$v) {
                        _vm.editorHtml = $$v
                      },
                      expression: "editorHtml",
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-wrapper" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons-wrapper is-flex is-justify-content-right" },
        [
          _c("div", { staticClass: "is-flex" }, [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "button is-primary is-large mr-0",
                  class: { "is-loading": _vm.isSending },
                  staticStyle: { margin: "10px" },
                  attrs: { disabled: _vm.bulkGroups.length === 0 },
                  on: { click: _vm.send },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("check")]),
                  _vm._v(" " + _vm._s(_vm.sendButtonLabel)),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }